export default "__VITE_ASSET__CK2MU5Pz__"